module.exports = __webpack_public_path__ + "static/img/1.b4d56e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/1.jpg
// module id = DOa8
// module chunks = 0